/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendTaxFormEmail} from '../api'

export const useMutationSendTaxFormEmail = createReactQueryMutationHook('sendTaxFormEmail', sendTaxFormEmail)
